import React from 'react'
import { useNavigate } from "react-router-dom";
function Header() {

   const navigate = useNavigate();

  const handleLogout = () => {
    // ✅ Remove any stored auth data
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("table_id"); // optional if you're storing it

    // ✅ Redirect to login
    navigate("/login");
  };
  return (
    <>
      <nav className="navbar p-0 fixed-top d-flex flex-row">
        <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
          <a className="navbar-brand brand-logo-mini" href="index.html"><img src="assets/images/logo-mini.svg" alt="logo" /></a>
        </div>
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
            <span className="mdi mdi-menu"></span>
          </button>
          <ul className="navbar-nav w-100">
            <a
                  className="dropdown-item preview-item d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  <div className="preview-thumbnail me-2">
                    <div className="preview-icon bg-dark rounded-circle d-flex justify-content-center align-items-center"
                      style={{ width: "35px", height: "35px", marginLeft:"824px"}}>
                      <i className="mdi mdi-logout text-danger" style={{ fontSize: "18px" }}></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-0">Log out</p>
                  </div>
                </a>
          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span className="mdi mdi-format-line-spacing"></span>
          </button>
        </div>
      </nav>
    </>
  )
}

export default Header
